'use-client';
import { Box, Flex, Grid, SimpleGrid, Text, Image } from "@chakra-ui/react";
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import config from '@config';
import KarmaSliderComponent from "./KarmaSliderComponent";
import ContentArea from "./ContentArea";
import Link from "next/link";
import { useBreakpointValue } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import { useEffect, useState } from "react";
import SimpleButton from "./Buttons/SimpleButton";


let KarmaBlogCategoryExplain = ({ sectionContent, styleConfig, sectionId }) => {

    let h1FontSize = useBreakpointValue({
        base: '36px',
        md: '72px'
    })
    let h1LineHeight = useBreakpointValue({
        base: '40px',
        md: '90px',
        xl: '131.93px'
    })
    let h1MarginBottom = useBreakpointValue({
        base: '0.7rem',
        lg: '0px'
    })

    const imageSrc = useBreakpointValue({
        base: sectionContent?.[1]?.mobileImage?.url,
        md: sectionContent?.[1]?.tabletImage?.url,
        lg: sectionContent?.[1]?.tabletImage?.url,
        xl: sectionContent?.[1]?.image?.url
    });

    return (
        <Box
        pos={'relative'}
        minH={{base: '271px', md: '320px', lg: '412px'}}
        bg={'#EFE7D6'}
        w={'100%'}
        bgImage={imageSrc}
        bgRepeat={'no-repeat'}
        backgroundSize="cover"
        display={'flex'}
        justifyContent={'center'}
        >
                <Box id="blog-category-explain-content" color={'red'} display={'flex'} 
                flexDirection={'row'} alignItems={'center'} justifyContent={'center'} width={'100%'}>
                    <ContentArea
                        tAlign={'center'}
                        fontFamily={'var(--FedraSansStd-book)'}
                        mainContent={sectionContent?.[0]?.body?.value}
                        sectionContent={sectionContent?.[0]?.body}
                        fontWeight={500}
                        color={"#000"}
                        font={{ base: '16px', md: '24px' }}
                        lineHeight={{base: '26px', md: '40px', xl: '35px'}}
                        width={{base: '90%', lg: '900px', xl: '1018px'}}
                    />
                </Box>

                <style>
                    {`#blog-category-explain-content h1 {
                        color: #B7870C;
                        font-size: ${h1FontSize};
                        line-height: ${h1LineHeight};
                        font-family: var(--AustinMedium);
                        font-weight: 500;
                        margin-bottom: ${h1MarginBottom};
                    }`}
                </style>
        </Box>
    )

}

export default KarmaBlogCategoryExplain;